<svg attr.viewBox="0 0 {{cols}} {{rows}}">
  <path [attr.d]="path" fill-rule="evenodd"/>
</svg>
